export default "__VITE_ASSET__OtgBqrye__"